"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tools = void 0;
var appTools = __importStar(require("./appTools"));
var commonFun = __importStar(require("./tools"));
var share = __importStar(require("./share"));
var request = __importStar(require("./request"));
var smartScroll_1 = __importDefault(require("./smartScroll"));
var bdLog = __importStar(require("./bdLog"));
var countDown = __importStar(require("./countDown"));
var dataStorage = __importStar(require("./dataStorage"));
var form = __importStar(require("./form"));
var mTracklog = __importStar(require("./mTracklog"));
var urlMethod = __importStar(require("./urlMethod"));
var vconsole_1 = require("./vconsole");
var getAdv_1 = require("./getAdv");
var lazyloadImg_1 = require("./lazyloadImg");
var wbLog = __importStar(require("./wubaLog"));
var copyText = __importStar(require("./copyText"));
var getScreenShotInfo = __importStar(require("./getScreenShotInfo"));
var getUploadImg_1 = require("./getUploadImg");
var wmdaTracklog = __importStar(require("./wmdaTracklog"));
var useCountDown_1 = __importDefault(require("./useCountDown"));
var NewcarCommonApis = __importStar(require("./newcarCommonApis"));
var AutoHooks = __importStar(require("./autoHooks"));
var carPurchaseCalculator = __importStar(require("./calculation"));
var PushState = __importStar(require("./pushState"));
var getExposureDom_1 = require("./getExposureDom");
// import * as EncryptionFn from './crypto'; // 不兼容安卓5
exports.tools = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, appTools), commonFun), bdLog), share), request), { smartScroll: smartScroll_1.default }), countDown), dataStorage), form), mTracklog), urlMethod), { addVconsole: vconsole_1.addVconsole,
    getAdv: getAdv_1.getAdv,
    lazyloadImg: lazyloadImg_1.lazyloadImg }), wbLog), copyText), getScreenShotInfo), { getUploadImg: getUploadImg_1.getUploadImg }), wmdaTracklog), { useCountDown: useCountDown_1.default }), NewcarCommonApis), AutoHooks), carPurchaseCalculator), PushState), { getExposureDom: getExposureDom_1.getExposureDom
    // ...EncryptionFn,
 });
